// import React, { useRef, useState } from 'react';
// import { useSelector } from "react-redux";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';
// import { Bar, Doughnut, Pie } from 'react-chartjs-2';
// import { BiDotsHorizontalRounded } from 'react-icons/bi';
// import { setDynamicModalObj } from '../../store/board.actions';

// ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, Tooltip, Legend);

// export function Graphicproject({ board, dynamicModalObj }) {
//   const elModalBtn = useRef();
//   const [chartType, setChartType] = useState('bar');
//   const DataInfo = useSelector(storeState => storeState.infoModulo.infoM);
//   const projectOptions = DataInfo?.projectOptions || []; // Usa la información del API



//   // Data para el gráfico
//   const data = {
//     labels: getLabelTitles(),
//     datasets: [
//       {
//         label: 'Estados de actividades',
//         data: getData(),
//         backgroundColor: getLabelColors(),
//         borderColor: getLabelColors(),
//         borderWidth: 1,
//       },
//     ],
//   };

 

  // Devuelve los nombres de los proyectos desde projectOptions
//   function getLabelTitles() {
//     return projectOptions.map(option => option.nombre_proyecto);
//   }

//   // Devuelve los colores de los proyectos desde projectOptions
//   function getLabelColors() {
//     return projectOptions.map(option => option.bgColor);
//   }

//   function getData() {
//     // Inicializa los conteos de actividades por proyecto
//     const projectCounts = {};
//     projectOptions.forEach(option => {
//       projectCounts[option.id_proyecto] = 0; // Inicializa con 0
//     });

//     // Cuenta las actividades en función del proyecto
//     board.forEach(group => {
//       group.actividades.forEach(actividad => {
//         const projectId = actividad.fk_proyecto_id;
//         if (projectId && projectCounts[projectId] !== undefined) {
//           projectCounts[projectId]++;
//         }
//       });
//     });

//     // Devuelve los conteos en el orden de projectOptions
//     return projectOptions.map(option => projectCounts[option.id_proyecto] || 0);
//   }

//   function onToggleTypeModal() {
//     const isOpen =
//       dynamicModalObj.chartType === 'label' && dynamicModalObj?.type === 'chart-type'
//         ? !dynamicModalObj.isOpen
//         : true;
//     const { x, y } = elModalBtn.current.getClientRects()[0];
//     setDynamicModalObj({
//       isOpen,
//       pos: { x: x - 110, y: y + 20 },
//       type: 'chart-type',
//       chartType: 'label',
//       setChartType,
//     });
//   }

//   function getChart(chartType) {
//     switch (chartType) {
//       case 'pie':
//         return <Pie data={data}  />;
//       case 'bar':
//         return <Bar data={data} />;
//       case 'doughnut':
//         return <Doughnut data={data} />;
//       default:
//         return null;
//     }
//   }
//   console.log("data",data);
//   return (
//     <section className="project-chart">
//       <div className="chart-header">
//         <div className="header-content">
//           <h2>Actividades por Proyecto</h2>
//           <span className="icon-container" ref={elModalBtn} onClick={onToggleTypeModal}>
//             <BiDotsHorizontalRounded />
//           </span>
//         </div>
//       </div>
//       <div className="chart-content">{getChart(chartType)}</div>
//     </section>
//   );
// }


// import React, { useRef, useState } from 'react';
// import { Bar } from 'react-chartjs-2';
// import { Chart as ChartJS, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';
// import { useSelector } from 'react-redux';

// ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

// export function Graphicproject({ board }) {
//       const DataInfo = useSelector(storeState => storeState.infoModulo.infoM);
//   const projectOptions = DataInfo?.projectOptions || []; // Usa la información del API

//   console.log(projectOptions);

//     console.log("board",board);
//   const staticData = {
//     labels: ["Proyectos"], // Solo una etiqueta para la barra
//     datasets: [
//       {
//         label: 'DINAMICA',
//         data: [12],  // El total de actividades para el proyecto DINAMICA
//         backgroundColor: "#ffcb00",
//       },
//       {
//         label: 'UNICA',
//         data: [3],  // El total de actividades para el proyecto UNICA
//         backgroundColor: "#007eb5",
//       },
//       {
//         label: 'MEDIOS DE VIDA 2024',
//         data: [4],  // El total de actividades para MEDIOS DE VIDA 2024
//         backgroundColor: "#9c51dd",
//       },
//       {
//         label: 'CDE/CIIE',
//         data: [2],  // El total de actividades para CDE/CIIE
//         backgroundColor: "#9dd327",
//       },
//       {
//         label: 'MERCASEM',
//         data: [6],  // El total de actividades para MERCASEM
//         backgroundColor: "#bb3354",
//       },
//       {
//         label: 'SIN BARRERAS',
//         data: [7],  // El total de actividades para SIN BARRERAS
//         backgroundColor: "#66cdfe",
//       },
//     ]
//   };

//   // Este sería el gráfico con los datos estáticos ajustados
//   return (
//     <section className="project-chart">
//       <h2>Actividades por Proyecto</h2>
//       <Bar
//         data={staticData}
//         options={{
//           maintainAspectRatio: true,
//           responsive: true,
//           plugins: {
//             legend: {
//               position: 'bottom',
//             },
//           },
//           scales: {
//             x: {
//               stacked: true, // Apilado en el eje X
//             },
//             y: {
//               stacked: true, // Apilado en el eje Y
//             }
//           },
//         }}
//       />
//     </section>
//   );
// }


import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Bar } from 'react-chartjs-2';

export function Graphicproject({ board }) {
  const [dynamicData, setDynamicData] = useState({});

  // Obtiene los datos del store
  const DataInfo = useSelector(storeState => storeState.infoModulo.infoM);
  const projectOptions = DataInfo?.projectOptions || [];

  // Función para contar las actividades de cada proyecto
  const getData = () => {
    const projectCounts = {};

    // Inicializa el conteo de actividades por proyecto
    projectOptions.forEach(option => {
      projectCounts[option.id_proyecto] = 0; // Todos los proyectos comienzan en 0
    });

    // Recorre las actividades y cuenta cuántas pertenecen a cada proyecto
    board?.forEach(group => {
      group?.actividades?.forEach(actividad => {
        const projectId = actividad?.fk_proyecto_id;
        if (projectId && projectCounts[projectId] !== undefined) {
          projectCounts[projectId]++;
        }
      });
    });

    return projectCounts;
  };

  // Usamos un efecto para cuando los datos cambian
  useEffect(() => {
    if (projectOptions?.length > 0 && board?.length > 0) {
      const projectCounts = getData();

      // Generar datos para el gráfico
      const labels = ['Actividades']; // Etiqueta general
      const datasets = projectOptions.map(option => ({
        label: option.nombre_proyecto || 'Sin título',
        data: [projectCounts[option.id_proyecto] || 0], // Total de actividades (0 si no tiene)
        backgroundColor: option.bgColor || '#000', // Color del proyecto
      }));

      const data = {
        labels: labels, // Solo una columna
        datasets: datasets,
      };

      setDynamicData(data);
    }
  }, [board, projectOptions]); // Dependencias para recalcular

  return (
    <section className="project-chart">
      <h2>Actividades por Proyecto</h2>
      {dynamicData.datasets?.length > 0 ? (
        <Bar
          data={dynamicData}
          options={{
            maintainAspectRatio: true,
            responsive: true,
            plugins: {
              legend: {
                position: 'bottom',
              },
            },
            scales: {
              x: {
                stacked: true, // Apilado en el eje X
              },
              y: {
                stacked: true, // Apilado en el eje Y
              },
            },
          }}
        />
      ) : (
        <p>No hay datos disponibles para mostrar.</p>
      )}
    </section>
  );
}
